import { firestore } from "../firebase";

const seleccionables = {};

seleccionables.countries = () => {
  return new Promise((resolve, reject) => {
    const query = firestore.collection("countries").orderBy("nombre");

    query
      .get({ source: "server" })
      .then((querySnapshot) => {
        let data = []; // clear previous results
        querySnapshot.forEach((doc) => {
          let docData = doc.data();
          data.push(docData);
        });
        resolve(data);
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

seleccionables.states = (idContry) => {
  return new Promise((resolve, reject) => {
    const query = firestore
      .collection("countries")
      .doc(idContry)
      .collection("states")
      .orderBy("nombre");
    query
      .get({ source: "server" })
      .then((querySnapshot) => {
        let data = []; // clear previous results
        querySnapshot.forEach((doc) => {
          let docData = doc.data();
          data.push(docData);
        });
        resolve(data);
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

seleccionables.municipalities = (idContry, idState) => {
  return new Promise((resolve, reject) => {
    const query = firestore
      .collection("countries")
      .doc(idContry)
      .collection("states")
      .doc(idState)
      .collection("municipalities")
      .orderBy("municipality");
    query
      .get({ source: "server" })
      .then((querySnapshot) => {
        let data = []; // clear previous results
        querySnapshot.forEach((doc) => {
          let docData = doc.data();
          data.push(docData);
        });
        resolve(data);
      })
      .catch((reason) => {
        reject(reason);
      });
  });
};

export default seleccionables;
